import { Component, OnInit } from '@angular/core';
import { BannerService } from '../../../services/banner/banner.service';
import { MarcaService } from '../../../services/marca/marca.service';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { ProductoService } from '../../../services/producto/producto.service';
import { CarritoService } from '../../../services/carrito/carrito.service';
import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import * as _ from 'lodash';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  slides: any[] = [];
  encualtraloEnSF: any[] = [];
  marcas: any[] = [];
  cFantasiaEspeciales: any[] = [];
  porductosDestacados: ElementoCarro[] = [];
  cantColumMarcas = 0;
  slideConfig = {'slidesToShow': 4, 'slidesToScroll': 4, 'arrows': true};

  bannersParams: any;
  cFantasiaEspecialesParams: any;
  bransParams: any;


  constructor(
    private _bannerService: BannerService,
    private _marcaService: MarcaService,
    private _categoriaService: CategoriaService,
    private _productoService: ProductoService,
    private _carritoService: CarritoService
  ) {
    this.bannersParams = {'per_page': 6};
    this.bransParams = {'per_page': 6};
    this.cFantasiaEspecialesParams = {'per_page': 6, 'visibility': ['HOME']};
  }

  ngOnInit() {
    this._bannerService.getActivosPorTipo('SLIDE')
      .subscribe( resp => {
        this.slides = resp.data;
      });

    this._bannerService.getActivosPorTipo('ENCUENTRALO_EN_SF', this.bannersParams)
      .subscribe( resp => {
        this.encualtraloEnSF = resp.data;
      });

    this._marcaService.getDestacadas(this.bransParams)
      .subscribe( data => {
        this.marcas = data;

        this.cantColumMarcas = Math.floor((12 / data.length));
      });

    this._categoriaService.getDeFantasia(this.cFantasiaEspecialesParams)
      .subscribe( data => {
        this.cFantasiaEspeciales = data;
      });

    this._productoService.getSeleccionSF()
      .subscribe( data => {

        this.porductosDestacados = this._carritoService.enriquecerProductos(data);

      });

    this._carritoService.carroProductos
      .subscribe( data => {

        this.porductosDestacados = this._carritoService.actualizarProductos(this.porductosDestacados);
      });

  }

  agregarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.agregarProducto(clon);
  }

  quitarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.quitarProducto(clon);
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/home/home.component.ts